import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  ApiURL = environment.ApiURL + '/admin';
  public headers_token: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers_token = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    });
  }

  getAllProducts(): Observable<any> {
    return this.http.get(this.ApiURL + '/Product', { headers: this.headers_token });
  }

  getproductByid(id): Observable<any> {
    return this.http.get(this.ApiURL + '/Product/' + id, { headers: this.headers_token });
  }

  addproduct(data: any): Observable<any> {
    let imgfile: File;
    imgfile = data.productImgObj;
    let formData = new FormData();
    formData.append("ProductCategoryID", data.ProductCategoryID);
    formData.append("Name", data.Name);
    formData.append("Capacity", data.Capacity);
    formData.append("Price", data.Price);
    formData.append("Description", data.Description);
    formData.append("isDisplayOnHome", data.isDisplayOnHome);
    formData.append("productImgObj", imgfile);
    return this.http.post(this.ApiURL + '/Product/AddProduct', formData);
  }

  editProduct(data: any): Observable<any> {
    let imgfile: File;
    imgfile = data.productImgObj;
    let formData = new FormData();
    formData.append("ProductID", data.Id);
    formData.append("ProductCategoryID", data.ProductCategoryID);
    formData.append("Name", data.Name);
    formData.append("Capacity", data.Capacity);
    formData.append("Price", data.Price);
    formData.append("Description", data.Description);
    formData.append("isDisplayOnHome", data.isDisplayOnHome);
    formData.append("productImgObj", imgfile);
    return this.http.post(this.ApiURL + '/Product/editproduct', formData);
  }

  deleteProduct(id: number): Observable<any> {
    return this.http.delete(this.ApiURL + '/Product/' + id, { headers: this.headers_token });
  }

  // ---------------------------------------------------------------------------
}
